<template>
  <el-card class="page-container h-full">
    <div ref="formHeightRef">
      <el-form :inline="true" :model="form" ref="form" @submit.native.prevent="search">
        <el-form-item label="" prop="keyWord">
          <el-input v-model="form.keyWord" placeholder="设备名称/编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="manufacturerCode">
          <el-select v-model="form.manufacturerCode" clearable placeholder="请选择设备厂商">
            <el-option
              v-for="item in facturerList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="status">
          <el-select v-model="form.status" clearable placeholder="请选择运行状态">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="在线" :value="1"></el-option>
            <el-option label="离线" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isPosition">
          <el-select v-model="form.isPosition" clearable placeholder="请选择点位设置">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="已设置点位" :value="true"></el-option>
            <el-option label="未设置点位" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isMonitorRange" v-if="showMonitorRangeColumn">
          <el-select v-model="form.isMonitorRange" clearable placeholder="请选择监控区域">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="已设置监控区域" :value="true"></el-option>
            <el-option label="未设置监控区域" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <!-- <template v-if="!hiddenBuildingFloor">
          <el-form-item label="" prop="buildingId">
            <el-select
              v-model="form.buildingId"
              clearable
              placeholder="请选择所属建筑"
              @change="buildingChange"
            >
              <el-option
                v-for="item in buildingOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="floorId">
            <el-select
              v-model="form.floorId"
              clearable
              placeholder="请选择所属楼层"
              :disabled="form.buildingId === ''"
            >
              <el-option
                v-for="item in floorOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </template> -->
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" :disabled="!$hasAccess('update')" @click="setPosition">{{
            locationSetName
          }}</el-button>
          <el-button type="primary" @click="downLoad">导出设备清单</el-button>
          <el-button type="primary" @click="importExcel">批量关联设备</el-button>
        </el-form-item>
        <el-button
          type="primary"
          @click="handleDownload"
          v-if="
            cerAndInsConfig.showDownload &&
              $route.path.includes('wiz-iot-management-tongre/monitor-manage/monitorList')
          "
          >{{ cerAndInsConfig.downloadName }}</el-button
        >
      </el-form>
    </div>

    <el-table
      :data="tableData"
      border
      stripe
      :height="`calc(100vh - 200px - ${formHeight}px)`"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" prop="seqNo" width="60" :align="alignType"></el-table-column>
      <el-table-column label="设备编码" prop="code" :align="alignType"></el-table-column>
      <el-table-column label="设备名称" prop="name" :align="alignType"></el-table-column>
      <el-table-column
        label="设备厂商"
        prop="manufacturerCode"
        show-overflow-tooltip
        :align="alignType"
      >
        <template slot-scope="{ row }">
          {{ factureMap[row.manufacturerCode] || row.manufacturerCode }}
        </template>
      </el-table-column>
      <el-table-column
        label="设备类型名称"
        prop="deviceType"
        show-overflow-tooltip
        :align="alignType"
      >
        <template slot-scope="{ row }">
          {{ deviceTypeMap[row.deviceType] || row.deviceType }}
        </template>
      </el-table-column>
      <template v-if="!hiddenBuildingFloor">
        <el-table-column
          label="所属建筑"
          prop="buildingName"
          show-overflow-tooltip
          :align="alignType"
        ></el-table-column>
        <el-table-column label="所属楼层" prop="floorName" :align="alignType"></el-table-column>
      </template>
      <el-table-column label="运行状态" prop="status" :align="alignType">
        <template slot-scope="{ row }">
          <div v-if="row.status === 1" class="successTextColor">在线</div>
          <div v-if="row.status === 2" class="infoText">离线</div>
          <div v-if="row.status === 0" class="infoText">未知</div>
        </template>
      </el-table-column>
      <el-table-column label="点位设置" prop="setPosition" :align="alignType">
        <template slot-scope="{ row }">
          {{ row.isSetPosition ? '√' : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="监控区域设置"
        prop="scope"
        :align="alignType"
        v-if="showMonitorRangeColumn"
      >
        <template slot-scope="{ row }">
          {{ row.isSetMonitorRange ? '√' : '-' }}
        </template>
      </el-table-column>
      <template v-if="!hiddenBuildingFloor">
        <el-table-column
          label="关联设备"
          prop="relevanceDevices"
          show-overflow-tooltip
          :align="alignType"
        ></el-table-column>
      </template>
      <el-table-column label="操作" :align="alignType" v-if="showOperationColumn">
        <template slot-scope="{ row }">
          <el-button size="small" @click="handlePlay(row)">播放</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <videoDialog
      v-if="videoDialogShow"
      :show.sync="videoDialogShow"
      :code="cameraCode"
      :name="cameraName"
      :pIid="pIid"
      :showControlPanel="true"
      :showHKControlPanel="showHKControlPanel"
      :manufacturerCode="manufacturerCode"
      :daHuaParams="daHuaParams"
      :cameraInfo="cameraInfo"
      :isWebControl="isWebControl"
    ></videoDialog>
    <!-- 上传组件 -->
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import tableHeightMixin from '@/mixins/tableHeightMixin'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
// import { BuildingApi, FloorApi } from '@wiz-api/personnel-position'
import FnMixins from '@/assets/js/fnMixins'
import videoDialog from '@/components/video/videoDialog'

const dataCategoryApi = new DataCategoryApi()
const iotDeviceApi = new IOTDeviceApi()
// const floorApi = new FloorApi()
// const buildingApi = new BuildingApi()

export default {
  name: 'CameraList',
  mixins: [tableHeightMixin, FnMixins],
  components: {
    videoDialog,
  },
  props: {
    // 设备类型编码
    deviceTypeCode: {
      type: String,
      default: '',
    },
    // 位置设置名称
    locationSetName: {
      type: String,
      default: '',
    },
    // 是否显示监控区域设置列
    showMonitorRangeColumn: {
      type: Boolean,
      default: false,
    },
    // 是否显示操作列
    showOperationColumn: {
      type: Boolean,
      default: false,
    },
    // 点位设置的跳转参数
    linkParam: {
      type: String,
      default: '',
    },
    // 是否隐藏关键字内容
    isHideKeyword: {
      type: Boolean,
      default: false,
    },
    // HideKeyWord的具体值
    hideKeyword: {
      type: String,
      default: '',
    },
    // 是否展示海康云台
    showHKControlPanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cameraCode: '',
      cameraName: '',
      videoDialogShow: false,
      pIid: '',
      facturerList: [],
      deviceTypeList: [],
      factureMap: {},
      deviceTypeMap: {},
      alignType: 'left',
      form: {
        keyWord: '',
        manufacturerCode: '',
        status: '',
        isPosition: '',
        isMonitorRange: '',
        floorId: '',
        buildingId: '',
      },
      IsbuildingEmpty: true, // 是否建筑为空
      buildingOption: [],
      floorOption: [],
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [
        // {
        //     "id": "57ae17e2-3ab8-11ef-ae79-72c68a5f4025",
        //     "tid": "3a139467-1216-2fd8-7b59-b7c7575f35de",
        //     "name": "大华摄像头1号",
        //     "code": "34020000011320000102",
        //     "status": 0,
        //     "externalId": "",
        //     "areaCode": null,
        //     "areaName": null,
        //     "pIid": "3a139468-e39f-ee71-776a-fcca8c44ca9a",
        //     "deviceType": "Camera",
        //     "manufacturerCode": "DaHua",
        //     "protocolTypeCode": "Dahua_Dss",
        //     "threeDPosition": "",
        //     "threeDAngleView": "",
        //     "threeDMonitorRange": "",
        //     "creationTime": "2024-07-05T18:21:29",
        //     "fieldValues": []
        // }
      ],
      tableLoading: false,
      daHuaParams: {
        id: '',
        externalId: '',
      },
      cameraInfo: {
        protocolTypeCode: '',
        StreamUrl: '',
        IpPort: '',
      },
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
    }
  },
  computed: {
    isWebControl() {
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config.isWebControl'
      )
    },
    wizIotConfig() {
      return Wiz.globalSettings.dynamicModules?.modules['wiz-iot-management-tongre']?.config || {}
    },
    hiddenBuildingFloor() {
      return this.wizIotConfig.hiddenBuildingFloor
    },
    cerAndInsConfig() {
      return Wiz.globalSettings.cerAndInsConfig ?? {}
    },
  },
  methods: {
    handleDownload() {
      const a = document.createElement('a')
      a.href = this.cerAndInsConfig.url
      a.download = this.cerAndInsConfig.name
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    formatDate(row, column, cellValue) {
      if (cellValue) return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    reset() {
      this.$refs.form.resetFields()
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const res = await iotDeviceApi.getDeviceWithDetailPageList({
        deviceTypeCode: this.deviceTypeCode,
        ...this.form,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      this.tableLoading = false
      if (res[1]) {
        res[1].items.forEach((item, index) => {
          item.seqNo =
            (this.initPagination.pageNum - 1) * this.initPagination.pageSize + (index + 1)
          item.isSetPosition = item.threeDPosition && JSON.parse(item.threeDPosition).length > 0
          item.isSetMonitorRange =
            item.threeDMonitorRange && JSON.parse(item.threeDMonitorRange).length > 0
        })
        this.tableData = res[1].items || []
        this.initPagination.total = res[1].totalCount
      }
    },
    // 下载导出文件
    async downLoad() {
      const opts = {
        deviceTypeCode: this.deviceTypeCode,
        ...this.form,
      }
      const [err, res] = await iotDeviceApi.getDeviceExport(opts)
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '设备清单.xlsx',
          data: res,
        })
      }
    },
    // 点位设置
    setPosition() {
      // 兼容低代码平台
      if (Wiz?.globalSettings?.globalConfig?.routerBase) {
        this.$router.push({
          path: `/${Wiz.globalSettings.globalConfig.routerBase}/wiz-iot-management-tongre/monitor-manage/cameraLocation`,
          query: {
            code: this.linkParam,
          },
        })
      } else {
        this.$router.push({
          name: 'cameraLocation',
          query: {
            code: this.linkParam,
          },
        })
      }
    },
    // 播放
    async handlePlay(row) {
      this.pIid = row.pIid
      // 字段名称待定
      this.cameraCode = row.code || ''
      this.cameraName = row.name || row.cameraName || ''

      this.manufacturerCode = row.manufacturerCode || ''
      // 大华WSPlayer 所需参数
      this.daHuaParams.id = row.id
      this.daHuaParams.externalId = row.externalId
      this.daHuaParams.externalId = row.code

      if (row.protocolTypeCode === 'RtspToWs') {
        this.cameraInfo = {
          protocolTypeCode: row.protocolTypeCode,
          StreamUrl: '',
          IpPort: '',
        }
        const fieldValues = row.fieldValues || []
        fieldValues.forEach((item) => {
          this.cameraInfo[item.fieldName] = item.fieldValue
        })
      } else {
        this.cameraInfo = {}
      }
      this.videoDialogShow = true
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer', 'IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        let facturerList = []
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') {
            // 设备厂商
            facturerList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateDeviceType') {
            // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        this.facturerList = facturerList
        this.deviceTypeList = deviceTypeList
        this.factureMap = facturerList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.deviceTypeMap = deviceTypeList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.getList()
      }
    },
    // 获取楼层下拉框数据
    // async getFloor(val) {
    //   console.log('getFloor', val)
    //   const data = {
    //     maxResultCount: 15,
    //     sceneId: this.modelFileId,
    //     skipCount: 0,
    //     buildingId: val,
    //   }
    //   const [err, res] = await floorApi.getList(data)
    //   if (!err && res) {
    //     console.log('12345', res)
    //     this.floorOption = res.items
    //   }
    // },
    // 获取建筑下拉框数据
    // async getBuild() {
    //   const data = {
    //     maxResultCount: 999,
    //     sceneId: this.modelFileId,
    //     skipCount: 0,
    //   }
    //   const [err, res] = await buildingApi.getList(data)
    //   if (!err && res) {
    //     this.buildingOption = res.items
    //   }
    // },
    // buildingChange(val) {
    //   console.log('buildingChange', val)
    //   if (val) {
    //     this.IsbuildingEmpty = false
    //     this.getFloor(val)
    //   } else {
    //     this.form.floorId = ''
    //     this.floorOption = []
    //   }
    // },
    // 下载导入模板
    async exportTemplate() {
      console.log('下载模板')
      const [err, res] = await iotDeviceApi.getIOTDeviceTemplateExcel()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '设备清单导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      let params = {}
      const [err1, res1] = await floorApi.getBuildingFloorImportFromExcelVerify({
        excelFile: formData.get('file'),
      })
      if (!err1 && res1) {
        params = res1
      } else {
        this.$message({
          showClose: true,
          message: '导入失败，请检查文件格式',
          type: 'error',
        })
        this.uploadFileProps.btnLoading = false
        return
      }
      const [err2, res2] = await iotDeviceApi.iOTDeviceAssociatedListImportFromExcel({
        excelFile: formData.get('file'),
        buildingFloorImportFromExcelStr: JSON.stringify(params),
      })
      if (!err2) {
        this.$message.success({
          showClose: true,
          message: '导入成功',
        })
        this.uploadFileProps.active = 2
        // this.uploadFileProps.successCount = res.successfullyCount
        // this.uploadFileProps.failureCount = res.failureCount
        // this.uploadFileProps.buffer = res.steamContent
        // this.uploadFileProps.resultFile = 1
        this.getList()
      }
      this.uploadFileProps.btnLoading = false
    },
    importExcel() {
      this.uploadFileProps.active = 0
      this.uploadFileProps.visible = true
    },
    exportResults() {},
  },
  async created() {
    this.getCategoryByCodes()
    // this.getBuild()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
.successTextColor {
  color: var(--tagSuccessText);
}
.infoText {
  color: var(--tagInfoText);
}
</style>
